import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/vehicle-driver-side.svg';
import { Icon } from '../Icon/Icon';
export const VehicleDriverSideIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
